import React from 'react';
import { motion } from 'framer-motion';
import { talentExample } from '../../data/noetivra';
import { fadeUp } from '../../utils/motion';
export function TalentDetails() {
  return <motion.figure {...fadeUp} data-id="element-1593" data-mp="km8nkpp5l502">
      <figcaption className="font-heading font-bold text-lg text-ink-dark mb-4" data-id="element-1594" data-mp="kkxmixn3ebcn">
        For a project manager role, a review might show:
      </figcaption>
      <div className="overflow-x-auto border border-line rounded-lg bg-white" data-id="element-1595" data-mp="blah80r8sleb">
        <table className="w-full min-w-[640px] text-left" data-id="element-1596" data-mp="bndjbj5o64ze">
          <thead className="bg-surface-muted" data-id="element-1597" data-mp="gley3rw2bi52">
            <tr data-id="element-1598" data-mp="gi0y2qavfl0s">
              <th scope="col" className="px-6 py-4 text-sm font-semibold text-ink-dark w-1/5" data-id="element-1599" data-mp="1nctdedaoqm8">
                Requirement
              </th>
              <th scope="col" className="px-6 py-4 text-sm font-semibold text-ink-dark" data-id="element-1600" data-mp="6mz8jtcoogxo">
                What the candidate demonstrated
              </th>
              <th scope="col" className="px-6 py-4 text-sm font-semibold text-ink-dark" data-id="element-1601" data-mp="20zyus5bkk9dx">
                Follow-up needed
              </th>
            </tr>
          </thead>
          <tbody data-id="element-1602" data-mp="360f6lovcquf">
            {talentExample.map(row => <tr key={row.requirement} className="border-t border-line align-top" data-id="element-1603" data-mp="3udl7oo6881jf">
                <th scope="row" className="px-6 py-5 font-heading font-semibold text-ink-dark" data-id="element-1604" data-mp="cy65lqzh307i">
                  {row.requirement}
                </th>
                <td className="px-6 py-5 text-ink-dark leading-relaxed" data-id="element-1605" data-mp="815wt8b8njcp">{row.demonstrated}</td>
                <td className="px-6 py-5 text-ink-muted leading-relaxed" data-id="element-1606" data-mp="3ggpoi2w9gtpn">{row.followUp}</td>
              </tr>)}
          </tbody>
        </table>
      </div>
      <p className="mt-6 text-lg text-ink-dark leading-relaxed" data-id="element-1607" data-mp="3pg2w0q0tr87q">
        The workspace would make strengths, gaps, and reviewer disagreements
        visible. Human reviewers would make the hiring decision.
      </p>
    </motion.figure>;
}